import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscriptionSync } from '../../support/state/useSubscriptionV2';
import { CaremapNotesModelFactory } from '../model/CaremapNotesModelFactory';
import { AlertPresenter } from '../../AlertBinder';
import { ICareMapNoteTarget } from '../model/ICareMapNoteTarget';

interface IUseNoteCreatorParams {
    noteTarget?: ICareMapNoteTarget;
    trackingFrom?: string;
    onSaved?: () => void;
}

export const useNoteCreator = ({ noteTarget, trackingFrom, onSaved }: IUseNoteCreatorParams) => {
    const notesFactory = useInstance(CaremapNotesModelFactory);
    const alert = useInstance(AlertPresenter);

    const noteVM = useSubscriptionSync(() => notesFactory.createFormForNewNote(noteTarget));

    const saveAndClose = async () => {
        if (!noteVM) {
            return;
        }
        try {
            await noteVM.save({ trackingFrom });
            onSaved?.();
        }
        catch (err: any) {
            alert.showAndLogError(err);
        }
    };

    return { noteVM, saveAndClose };
};
